export const mariaDate = (d) => {
  return d.toISOString().replace("T", " ").replace("Z", "");
};

export const parsePaymentFormData = (form) => {
  const out = {
    customer_id: Number(form.get("customer_id")),
    invoices: [],
  };

  // Collect invoice rows like invoices[0][field]
  for (const [key, value] of form.entries()) {
    const m = key.match(/^invoices\[(\d+)\]\[(.+)\]$/);
    if (!m) continue;
    const idx = Number(m[1]);
    const field = m[2];
    if (!out.invoices[idx]) out.invoices[idx] = {};
    out.invoices[idx][field] = value;
  }

  // Normalize types
  out.invoices = out.invoices.map((r) => ({
    invoice_id: Number(r.invoice_id),
    pending: Number(r.pending ?? 0),
    amount: r.amount === "" || r.amount == null ? null : Number(r.amount),
    payment_date: r.payment_date || "", // keep string; schema-old checks required when amount > 0
    notes: (r.notes ?? "").trim(),
    customer_id: out.customer_id, // ensure present for each row (schema-old expects it)
  }));

  return out;
};

export const humanize = (str) => {
  let i,
    frags = str.split("_");
  for (i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(" ").replace("[]", "");
};

export const initialState = {
  meta: {
    code: 0,
    message: "",
  },
};
